export default class ProjectRepository {
  getProjects() {
    return [
      {
        id: "aga-home",
        url: "#/project/aga-home",
        imgSrc: "projects/aga-house/aga_house_1.jpg",
        title: "Dom Agi i Adama",
        // description: "...",
        photograph: "Piotr Krochmal",
        galleryImages: [
          "projects/aga-house/aga_house_1.jpg",
          "projects/aga-house/aga_house_2.jpg",
          "projects/aga-house/aga_house_3.jpg",
          "projects/aga-house/aga_house_4.jpg",
          "projects/aga-house/aga_house_5.jpg",
          "projects/aga-house/aga_house_6.jpg",
          "projects/aga-house/aga_house_7.jpg",
          "projects/aga-house/aga_house_8.jpg",
          "projects/aga-house/aga_house_9.jpg",
          "projects/aga-house/aga_house_10.jpg",
          "projects/aga-house/aga_house_11.jpg",
          "projects/aga-house/aga_house_12.jpg"
        ]
      },
      {
        id: "unesco",
        url: "#/project/unesco",
        imgSrc: "projects/unesco/unesco_1.jpg",
        title: "Ceremonia zamknięcia 41.Sesji Komitetu Światowego Dziedzictwa UNESCO",
        // description: "...",
        photograph: "Piotr Palka",
        galleryImages: [
          "projects/unesco/unesco_1.jpg",
          "projects/unesco/unesco_1a.jpg",
          "projects/unesco/unesco_1b.jpg",
          "projects/unesco/unesco_1c.jpg",
          "projects/unesco/unesco_1d.jpg",
          "projects/unesco/unesco_1e.jpg",
          "projects/unesco/unesco_1f.jpg",
          "projects/unesco/unesco_1g.jpg",
          "projects/unesco/unesco_1h.jpg",
          "projects/unesco/unesco_2a.jpg",
          "projects/unesco/unesco_2b.jpg",
          "projects/unesco/unesco_2c.jpg",
          "projects/unesco/unesco_2d.jpg"
        ]
      },
      {
        id: "bible",
        url: "#/project/bible",
        imgSrc: "projects/bible/bible_1.jpg",
        title: '"Dawno, dawno temu..."',
        // description: "...",
        photograph: "Piotr Palka",
        galleryImages: [
          "projects/bible/bible_1.jpg",
          "projects/bible/bible_2.jpg",
          "projects/bible/bible_3.jpg",
          "projects/bible/bible_4.jpg",
          "projects/bible/bible_5.jpg",
          "projects/bible/bible_6.jpg",
          "projects/bible/bible_7.jpg",
          "projects/bible/bible_8.jpg",
          "projects/bible/bible_9.jpg",
          "projects/bible/bible_10.jpg",
          "projects/bible/bible_11.jpg",
          "projects/bible/bible_12.jpg"
        ]
      }
    ]
  }
}
